import React from "react";

function HowCountCom({ num, header, sub, color }) {
  return (
    <div className="flex my-3 gap-8 xl:w-[70%]">
      <div>
        <div>
          <p
            className={`
              ${color} border-2 bg-white border-[#1E222B] 
              rounded-full w-20 h-20 
              flex items-center justify-center 
              text-[24px] font-bold
            `}
          >
            {num}
          </p>
        </div>
      </div>

      <div>
        <h1 className="font-[400] text-[16px] sm:text-[32px] mb-2">{header}</h1>
        <div className="font-[400] text-[14px] sm:text-[18px] mb-2">{sub}</div>
      </div>
    </div>
  );
}

export default HowCountCom;
